<script setup lang="ts">
import PartTitleHead from '@parts/part-title-head.vue';
import PartInviteBox from '@parts/part-invite-box.vue';
import {useI18n} from "vue-i18n";
import {computed, onBeforeMount, ref} from "vue";
import {Referral} from "@store/api/interfaces";
import {useUserApi} from "@store/api/userApi";
import CoreLoader from "@core/core-loader.vue";
import ButtonPrimary from '@buttons/button-primary.vue';
import PartFooterNavigation from '@parts/part-footer-navigation.vue';

const {t} = useI18n();
const referralInfo = ref<Referral | null>(null);
const isLoading = ref<boolean>(false);
const userApi = useUserApi();

const fields = computed(() => {
  return {
    label: {
      title: t('invite.referral_system'),
      icon: {name: 'users', viewBox: '0 0 18 16'}
    },
	icon: '/images/share-icon.svg',
	iconLabel: t('invite.referral_system'),
    title: t('invite.title'),
    subtitle: t('invite.description'),
    invite: {
      title: t('invite.link'),
      message: t('invite.message'),
      link: referralInfo.value?.link ?? '',
      count: referralInfo.value?.activations ?? 0,
      paid: referralInfo.value?.paid ?? 0,
    },
	backButton: {
		title: t('common.buttons.back'),
		url: "/"
	}
  }
});

onBeforeMount(async () => {
  isLoading.value = true;
  referralInfo.value = await userApi.getReferralInfo();
  isLoading.value = false;
});
</script>

<template>
  <section class="section-invite">
    <div class="wrapper">
      <!-- <transition
          appear
          name="fade"
          style="--animation-delay: 0s"
      >
        <part-label
            v-if="fields.label"
            class="section-invite__label"
            :icon="fields.label?.icon"
            bordered
        >
          {{ fields.label.title }}
        </part-label>
      </transition> -->

      <transition
          appear
          name="fade"
          style="--animation-delay: 0.2s"
      >
        <part-title-head
            v-if="fields.title || fields.subtitle"
            :title="fields.title"
			:icon="fields?.icon"
			:iconLabel="fields?.iconLabel"
            :subtitle="fields.subtitle"
            class="section-invite__content"
        ></part-title-head>
      </transition>

      <transition
          v-if="!isLoading"
          appear
          name="show-up"
          style="--animation-delay: 0.4s"
      >
        <part-invite-box
            class="section-invite__box"
            :title="fields.invite.title"
            :message="fields.invite.message"
            :link="fields.invite.link"
            :count="fields.invite.count"
            :paid="fields.invite.paid"
        >
        </part-invite-box>
      </transition>
      <transition
          v-else
          appear
          name="show-up"
          style="--animation-delay: 0.3s"
      >
        <core-loader
            inline
            :title="t('common.loader.invite_link')"
        />
      </transition>

		<part-footer-navigation
			v-if="fields?.backButton && !isLoading"
		>
			<button-primary
				pink
				class="page-history__back"
				:to="fields.backButton.url"
			>
				{{ fields.backButton.title }}
			</button-primary>
		</part-footer-navigation>
    </div>
  </section>
</template>

<style lang="scss">
.section-invite {
	//   padding-top: 5.1rem;
	padding-bottom: 2.5rem;

	&__label {
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		margin: auto auto 2.4rem;
	}

	&__box {
		margin-bottom: 3.2rem;
		@include min-desktop {
			margin-bottom: 6.4rem;
		}
	}

	&__content {
		padding-left: 0.8rem;
		padding-right: 0.8rem;
		margin-bottom: 3.2rem;
		--icon-width: 7.3rem;

		.part-title-head__title {
			max-width: 27rem;
			margin-left: auto;
			margin-right: auto;
			@include min-desktop {
				max-width: 29rem;
			}
		}
	}
}
</style>
